import dayjs from 'dayjs';

const PENDING_STATUS = 'Pending';

export const SEARCH_PLACEHOLDER = 'Search by posting ID, X3 product name or approver name';
export const MONTHLY_RECONCILIATION_VARIANCE_COLOR = '#BA4246';

const parseMonthYear = (value) => {
  if (!value || value === PENDING_STATUS) return null;

  let parsed = dayjs(value, 'MMMM YYYY', true);
  if (parsed.isValid()) return parsed;

  parsed = dayjs(value, 'MMM YYYY', true);
  return parsed.isValid() ? parsed : null;
};

const dateComparator = (a, b) => {
  const aDate = parseMonthYear(a);
  const bDate = parseMonthYear(b);

  if (!aDate && !bDate) return 0;
  if (!aDate) return 1;
  if (!bDate) return -1;

  return aDate.diff(bDate);
};

const dateStringComparator = (a, b) => {
  const aDate = a ? dayjs(a) : null;
  const bDate = b ? dayjs(b) : null;

  if (!aDate && !bDate) return 0;
  if (!aDate?.isValid() && !bDate?.isValid()) return 0;
  if (!aDate?.isValid()) return 1;
  if (!bDate?.isValid()) return -1;

  return aDate.diff(bDate);
};

export const SORT_COMPARATORS = {
  open: {
    lastApprovedMonth: (a, b) => {
      const aIsPending = !a || a === PENDING_STATUS;
      const bIsPending = !b || b === PENDING_STATUS;

      if (aIsPending && bIsPending) return 0;
      if (aIsPending) return 1;
      if (bIsPending) return -1;

      return dateComparator(a, b);
    },
  },
  finalized: {
    lastApprovedMonth: dateComparator,
    finalizedDate: dateStringComparator,
  },
};
export const DATE_CONSTANTS = {
  START_DATE_MIN: '2026-01-01',
};
